import { error, ERROR_INVALID_NUMBER, ERROR_INVALID_BIRTHDATE } from './NationalNumber'

const validateBirthdate = (number, birthdateOnly) => {
    const errors = []

    number = String(number)
    if (number.length !== 6 || isNaN(parseInt(number))) {
        errors.push(error(birthdateOnly ? ERROR_INVALID_BIRTHDATE : ERROR_INVALID_NUMBER))
        return errors
    }

    const day = parseInt(number.substring(0, 2))
    const month = parseInt(number.substring(2, 4))
    const year = parseInt(number.substring(4, 6))

    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 0) {
        errors.push(error(birthdateOnly ? ERROR_INVALID_BIRTHDATE : ERROR_INVALID_NUMBER))
    }

    return errors
}

const validateNationalNumber = (number) => {
    const errors = []

    if (isNaN(parseInt(number)) || number.length !== 11) {
        errors.push(error(ERROR_INVALID_NUMBER))
        return errors
    }

    const values = number.split('').map(num => parseInt(num))
    const checkSum1Weight = [3, 7, 6, 1, 8, 9, 4, 5, 2]
    let checkSum1 = 11 - values.map(function (val, i) {
        let weight = checkSum1Weight[i] === undefined ? 0 : checkSum1Weight[i]
        return (val * weight)
    }).reduce((sum, val) => sum += val, 0) % 11

    if (checkSum1 === 11) {
        checkSum1 = 0
    }
    const checkSum2Weight = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
    let checkSum2 = 11 - values.map(function (val, i) {
        let weight = checkSum2Weight[i] === undefined ? 0 : checkSum2Weight[i]
        return (val * weight)
    }).reduce((sum, val) => sum += val, 0) % 11

    if (checkSum2 === 11) {
        checkSum2 = 0
    }

    if (checkSum1 !== values[9] && checkSum2 !== values[10]) {
        errors.push(error(ERROR_INVALID_NUMBER))
    }
    return errors
}

export default (number) => {
    return {
        number: number,
        errors: [],
        format: function () {
            return number
        },
        formatMasked: function () {
            if (!this.isValid()) {
                return this.format()
            }
            return this.number.substring(0, 6) + '*****'
        },
        formatUnmasked: function () {
            return this.format()
        },
        validate: function () {
            this.errors = []
            if (isNaN(parseInt(this.number))) {
                this.errors.push(error(ERROR_INVALID_NUMBER))
                return this.errors
            }
            switch (this.number.length) {
                case 6:
                    this.errors = validateBirthdate(this.number)
                    break
                case 11:
                    this.errors = validateNationalNumber(this.number)
                    break
                default:
                    this.errors.push(error(ERROR_INVALID_NUMBER))
            }

            return this.errors
        },
        validateBirthdate: function () {
            return validateBirthdate(this.number, true)
        },
        validateNationalNumber: function () {
            return validateNationalNumber(this.number)
        },
        isNationalNumber() {
            return validateNationalNumber(this.number).length === 0
        },
        isValid() {
            return this.validate().length === 0
        },
        isValidBirthdate() {
            return this.validateBirthdate().length === 0
        },
        isValidNationalNumber() {
            return this.validateNationalNumber().length === 0
        },
        isMale: function () {
            if (!this.isValid() || !this.isNationalNumber()) {
                return false
            }
            return this.number.charAt(8) % 2 > 0
        },
        isFemale: function () {
            if (!this.isValid() || !this.isNationalNumber()) {
                return false
            }
            return !this.isMale()
        },
        birthdate: function () {
            if (!this.isValid()) {
                return this.format()
            }

            const dNum = parseInt(this.number.substring(0, 1))
            const rest = this.number.substring(1, 6)

            return String(dNum > 3 ? dNum-4 : dNum) + rest
        },
        formattedBirthdate: function () {
            return this.birthdate()
        },
    }
}